var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block without-footer map"},[_c('div',{staticClass:"header"},[_vm._v("現地マップ")]),_c('div',{staticClass:"body"},[_c('Map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"zoom":_vm.zoom,"markers":_vm.markers,"fitness":_vm.fitness,"center":_vm.center}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }